import React, { useEffect } from "react";
import { useLocation, withRouter } from "react-router-dom";

import { USER_TYPE, UserType } from "../../../constants/UserTypeConstants";
import { Event, EventTracker } from "../../../tracking/service/EventTracker/EventTrackerService";
import { useProgressPercentEffect } from "../Common/hooks/useProgressPercentEffect";
import { useRedirect } from "../Common/hooks/useRedirect";
import { useRegistrationContext } from "../Common/registrationContext";
import { useRegistrationSignUpForm } from "../Common/registrationState";
import { REGISTRATION_PROGRESS_PERCENT } from "../Common/service";
import { RegistrationPageContainer } from "../RegistrationPageContainer/RegistrationPageContainer";

import { RegistrationSignUpForm } from "./RegistrationSignUpForm";
import { FormProvider } from "./RegistrationSignUpFormContext";
import { useSave, useValidate } from "./service";

const RegistrationSignup = () => {
  const registrationSignUpForm = useRegistrationSignUpForm();
  const { redirectToLanding } = useRedirect();
  const { save } = useSave();
  const { validate } = useValidate();
  const { registrationContext, setRegistrationContext } = useRegistrationContext();
  const location = useLocation();
  const { firstName, lastName, userType } =
    (location?.state as { firstName: string; lastName: string; userType: UserType }) || {};

  const sendTrackingEvent = ({ registrationContext }: { registrationContext: any }) => {
    switch (registrationContext.userType) {
      case USER_TYPE.VET_USER_TYPE:
        EventTracker.send({
          eventName: Event.Name.VET_VIEW_CONTACT,
          eventType: Event.Type.PAGE_VIEW,
          entityType: Event.Entity.VET,
          entityId: registrationContext.entityId,
        });
        break;
      case USER_TYPE.TECH_USER_TYPE:
        EventTracker.send({
          eventName: Event.Name.TECH_VIEW_CONTACT,
          eventType: Event.Type.PAGE_VIEW,
          entityType: Event.Entity.TECH,
          entityId: registrationContext.entityId,
        });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    sendTrackingEvent({ registrationContext });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (firstName && lastName && userType) {
      setRegistrationContext((prevContext) => ({
        ...prevContext,
        registrationContext: {
          ...prevContext.registrationContext,
          firstName,
          lastName,
          userType,
        },
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstName, lastName, userType]);

  useProgressPercentEffect(REGISTRATION_PROGRESS_PERCENT.SignUp);

  return (
    <RegistrationPageContainer linkProps={{ children: "Back to Name", onClick: redirectToLanding }}>
      <FormProvider defaultForm={registrationSignUpForm} save={save} validate={validate}>
        <RegistrationSignUpForm />
      </FormProvider>
    </RegistrationPageContainer>
  );
};

// eslint-disable-next-line no-restricted-exports
export default withRouter(RegistrationSignup);
